export default "__VITE_ASSET__CV5Xoku6__"